"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_FONT_SIZE_MAP = {
  xLarge: 3,
  large: 2,
  default: 1.6,
  medium: 1.4,
  small: 1.2,
  xSmall: 1
};
exports.DEFAULT_SCENARIO_NODE_THEME = {
  scale: 1,
  fontSize: DEFAULT_FONT_SIZE_MAP,
  maxWidth: 33,
  minWidth: 28
};

exports.initNodeTheme = function (scale) {
  return {
    scale: scale,
    fontSize: {
      xLarge: DEFAULT_FONT_SIZE_MAP.xLarge * scale,
      large: DEFAULT_FONT_SIZE_MAP.large * scale,
      default: DEFAULT_FONT_SIZE_MAP.default * scale,
      medium: DEFAULT_FONT_SIZE_MAP.medium * scale,
      small: DEFAULT_FONT_SIZE_MAP.small * scale,
      xSmall: DEFAULT_FONT_SIZE_MAP.xSmall * scale
    },
    maxWidth: exports.DEFAULT_SCENARIO_NODE_THEME.maxWidth * Math.pow(scale, scale),
    minWidth: exports.DEFAULT_SCENARIO_NODE_THEME.minWidth * Math.pow(scale, scale)
  };
};